import React, { useEffect, useState } from 'react';
import { Card, Form, Input, Button, Row, Col, Space, Breadcrumb } from 'antd';
import { showSuccess, showError } from '../../../../components/errorHandler';
import { apiRequest } from '../../../../service/apiRequest';

const SmsSettings: React.FC = () => {
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        setLoading(true);
        const response = await apiRequest({ method: 'get', url: '/sms-setting' });
        console.log('Fetched sms settings:', response);
        if (response) {
          form.setFieldsValue(response);  // <-- This is correct
        }
      } catch (error) {
        showError('Failed to load sms settings');
      } finally {
        setLoading(false);
      }
    };

    fetchSettings();
  }, [form]);
  const handleSave = async (values: any) => {
    try {
      await apiRequest({
        method: 'put',
        url: '/save-sms-settings', // ✅ your backend endpoint
        data: values,
      });
      showSuccess('SMS settings saved successfully');
    } catch (error) {
      showError('Failed to save SMS settings');
    }
  };

  return (
    <Space direction="vertical" style={{ width: '100%' }} size="large">
      <Breadcrumb items={[{ title: 'Dashboard' }, { title: 'SMS Settings' }]} />
      <Row gutter={16} justify="center">
        <Col span={12}>
          <Card title="SMS Settings">
            <Form
              layout="vertical"
              form={form}
              onFinish={handleSave}
              initialValues={{
                ss_sms_sender_id: '',
                ss_sms_api_key: '',
              }}
            >
              <Form.Item
                label="Sender ID"
                name="ss_sms_sender_id"
                rules={[{ required: true, message: 'Sender ID is required' }]}
              >
                <Input placeholder="Enter SMS sender ID" />
              </Form.Item>

              <Form.Item
                label="API Key"
                name="ss_sms_api_key"
                rules={[{ required: true, message: 'API Key is required' }]}
              >
                <Input.Password placeholder="Enter SMS API key" />
              </Form.Item>

              <Form.Item>
                <Button type="primary" htmlType="submit" block>
                  Save SMS Settings
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </Space>
  );
};

export default SmsSettings;
